import Reflux from "reflux";

export default Reflux.createActions([
  "loadError",
  "loadNotifications",
  "requestNotifications",
]);
